import { makeStyles } from "@material-ui/core";
const styles = makeStyles({
    root: { display: 'flex', flexDirection: 'column' },
    header: { padding: '1rem', backgroundColor: '#08090A', fontSize: '1.125rem', fontWeight: '400', color: '#FFFFFF', display: 'flex', justifyContent: 'space-between' },
    content: { backgroundColor: '#FFFFFF', padding: '0.5rem 1rem' },
})
export default styles;